import { applyMiddleware } from "redux";
import reduxThunk from "redux-thunk";
import { routerMiddleware } from "react-router-redux";
import history from "../history";
import ajax from "./ajax";
import sentry from "./sentry";
import routeRole from "./routeRole";
import routeRoleApp from "./routeRoleApp";
import segment from "./segment";

const router = routerMiddleware(history);

const middlewares = [reduxThunk, ajax, router, sentry, routeRole, routeRoleApp, segment];

export default applyMiddleware(...middlewares);
